/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Go_To_SlideInputs */



/**
* | output |
* | --- |
* | "Go to slide {index}" |
*
* @param {Go_To_SlideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const go_to_slide = /** @type {((inputs: Go_To_SlideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_To_SlideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Aller à la diapositive ${i?.index}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Gehen Sie zu Folie ${i?.index}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Vai alla diapositiva ${i?.index}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Перейти к слайду ${i?.index}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ir a la diapositiva ${i?.index}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`转到幻灯片${i?.index}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`スライドへ移動 ${i?.index}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्लाइड ${i?.index} पर जाएं`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Vá para o slide ${i?.index}`)
	return /** @type {LocalizedString} */ (`Go to slide ${i?.index}`)
});